import "./index.scss";
import Lottie from "react-lottie-player";
const an403 = require("../../../assets/animations/an-403.json");

const ForbiddenScreen = () => {
  return (
    <div id="forbidden-container" className="center-all">
      <Lottie loop animationData={an403} />
    </div>
  );
};

export default ForbiddenScreen;
